/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_HelpInputs */

const fr_about_help = /** @type {(inputs: About_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide & FAQ`)
};

const en_about_help = /** @type {(inputs: About_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help & FAQ`)
};

/**
* | output |
* | --- |
* | "Help & FAQ" |
*
* @param {About_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_help = /** @type {((inputs?: About_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_help(inputs)
	return en_about_help(inputs)
});